<template>
    <div class="prop-box">

        <div v-for="(item, index) in myBottomTab.navigationbar.tabs" :key="index" class="tab-item">
            <div class="tab-header">
                <span class="title">tab{{ index + 1 }}</span>

                <div class="menu">
                    <el-icon size="20px" color="#409EFC" style="margin-right:5px" @click="moveDownTab(item)">
                        <Bottom />
                    </el-icon>
                    <el-icon size="20px" color="#FF0000" @click="deleteTab(item)">
                        <Delete />
                    </el-icon>
                </div>
            </div>
            <el-form label-width="auto">
                <el-form-item label="标题">
                    <el-input v-model="item.name"></el-input>
                </el-form-item>
                <el-form-item label="默认选中">
                    <el-radio-group v-model="item.is_default">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="暗黑模式">
                    <el-radio-group v-model="item.is_dark">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="item.type">
                        <el-option v-for="item, index in tabTypeOptions" :label="item.name" :value="item.value"
                            :key="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <div style="text-align: center;margin-bottom: 15px;">
            <PropButton text="添加标题" @click="onClickAddTab"></PropButton>
        </div>

        <div class="section-title">样式设置</div>
        <el-form label-width="auto">
            <el-form-item label="文本大小">
                <el-input-number :min="0" v-model="myBottomTab.navigationbar.title_size"></el-input-number>
            </el-form-item>
            <el-form-item label="文本位置">
                <el-radio-group v-model="myBottomTab.navigationbar.position">
                    <el-radio-button label="left">左</el-radio-button>
                    <el-radio-button label="center">中</el-radio-button>
                    <el-radio-button label="right">右</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="左icons">
                <el-autocomplete clearable v-model="queryLeft" :fetch-suggestions="querySearch" placeholder="搜索/选择素材组"
                    @select="(item) => handleSelect(item, 'left')" @clear="onClear('left')"></el-autocomplete>
            </el-form-item>

            <el-form-item label="右icons">
                <el-autocomplete clearable v-model="queryRight" :fetch-suggestions="querySearch" placeholder="搜索/选择素材组"
                    @select="(item) => handleSelect(item, 'right')" @clear="onClear('right')"></el-autocomplete>
                <div></div>
            </el-form-item>
        </el-form>

        <p class="section-title">色值</p>
        <div class="color-box">
            <el-color-picker class="color-wrapper" v-model="myBottomTab.navigationbar.color_select">
            </el-color-picker>
            <p>选中色值{{ myBottomTab.navigationbar.color_select }}</p>
        </div>
        <div class="color-box">
            <el-color-picker class="color-wrapper" v-model="myBottomTab.navigationbar.color_default">
            </el-color-picker>
            <p>默认色值{{ myBottomTab.navigationbar.color_default }}</p>
        </div>

    </div>
</template>

<script>

import { TabJson, TabTypeOptions } from '@/common/const'
import { Delete, Bottom } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'
import { GetMaterialGroupList } from '@/request/api'
import { generateUUID } from '@/common/deco'
import PropButton from '@/components/PropButton.vue'

export default {
    name: "NavigationBarProp",
    components: {
        PropButton,
        Delete,
        Bottom
    },
    props: ['bottomTab'],
    data() {
        return {
            myBottomTab: this.bottomTab,
            tabTypeOptions: TabTypeOptions,
            queryLeft: '',
            queryRight: ''
        }
    },
    mounted() {
        this.queryLeft = this.bottomTab.ignore.top_left_source_name
        this.queryRight = this.bottomTab.ignore.top_right_source_name
    },
    methods: {
        /**
         * 点击添加标题
         */
        onClickAddTab() {
            console.log('onClickAddTab')
            const newTab = JSON.parse(JSON.stringify(TabJson))
            newTab.anchor_sid = generateUUID()
            if (!this.myBottomTab.navigationbar.tabs) {
                this.myBottomTab.navigationbar.tabs = []
            }
            this.myBottomTab.navigationbar.tabs.push(newTab)
        },
        /**
         * 下移
         */
        moveDownTab(item) {
            console.log('moveDownTab', item)
            const index = this.myBottomTab.navigationbar.tabs.indexOf(item)
            if (index == this.myBottomTab.navigationbar.tabs.length - 1) {
                this.$message.warning('已经到底了')
                return
            }
            let delTab = this.myBottomTab.navigationbar.tabs.splice(index, 1);
            this.myBottomTab.navigationbar.tabs.splice(index + 1, 0, ...delTab);
        },
        /**
        * 删除
        */
        deleteTab(item) {
            ElMessageBox.confirm('确定删除这个tab吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            })
                .then(() => {
                    const index = this.myBottomTab.navigationbar.tabs.indexOf(item)
                    this.myBottomTab.navigationbar.tabs.splice(index, 1)
                    this.$message.success('删除成功')
                })
        },
        /**
         * 搜索素材组
         */
        querySearch(queryString, cb) {
            console.log('querySearch', queryString)
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetMaterialGroupList(params)
                .then(data => {
                    var list = []
                    if (data.list) {
                        list = data.list.map(item => {
                            return {
                                value: item.name,
                                id: item.materialGroupID
                            }
                        })
                    }
                    cb(list)
                })
                .catch(error => {
                    console.error('素材组列表', error)
                })
        },
        /**
         * 选中素材组
         */
        handleSelect(item, type) {
            if (type == 'left') {
                this.myBottomTab.top_left_source = {
                    type: "material_group",
                    params: {
                        "material_group_id": ''
                    }
                }
                this.myBottomTab.top_left_source.params.material_group_id = item.id
                this.myBottomTab.ignore.top_left_source_name = item.value
            } else if (type == 'right') {
                this.myBottomTab.top_right_source = {
                    type: "material_group",
                    params: {
                        "material_group_id": ''
                    }
                }
                this.myBottomTab.top_right_source.params.material_group_id = item.id
                this.myBottomTab.ignore.top_right_source_name = item.value
            }
        },
        /**
         * 清除输入框
         */
        onClear(type) {
            if (type == 'left') {
                this.myBottomTab.top_left_source.params.material_group_id = ''
                this.myBottomTab.ignore.top_left_source_name = ''
            } else if (type == 'right') {
                this.myBottomTab.top_right_source.params.material_group_id = ''
                this.myBottomTab.ignore.top_right_source_name = ''
            }
        }
    },
    watch: {
        bottomTab(newValue, oldValue) {
            this.myBottomTab = newValue
            console.log(newValue, oldValue)
        }
    }
}
</script>

<style scoped lang="less">
.tab-item {
    margin-bottom: 15px;
}

.tab-header {
    position: relative;
    height: 30px;

    .title {
        font-size: medium;
        font-weight: bold;
    }

    .menu {
        position: absolute;
        top: 0;
        right: 10px;
    }
}

.color-wrapper {
    width: 80%;
    height: 50px;
    margin-left: 10%;
}

:deep(.el-color-picker) {
    width: 80%;
    height: 50px;
}

:deep(.el-color-picker__trigger) {
    width: 100%;
    height: 100%;
    padding: 0;
}

.color-box {
    text-align: center;

    p {
        color: gray;
        font-size: small;
    }
}
</style>